__turbopack_context__.v({
  "caption": "ImagePlugin-module-scss-module__WdQ30G__caption",
  "image": "ImagePlugin-module-scss-module__WdQ30G__image",
  "imageContainer": "ImagePlugin-module-scss-module__WdQ30G__imageContainer",
  "imageStretched": "ImagePlugin-module-scss-module__WdQ30G__imageStretched",
  "imageWithBackground": "ImagePlugin-module-scss-module__WdQ30G__imageWithBackground",
  "imageWithBorder": "ImagePlugin-module-scss-module__WdQ30G__imageWithBorder",
});
